/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_TitleInputs */



/**
* | output |
* | --- |
* | "Event Position" |
*
* @param {Position_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_title = /** @type {((inputs?: Position_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position de l'Evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsposition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントポジション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना की स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição do evento")
	return /** @type {LocalizedString} */ ("Event Position")
});